// Newsletter-Popup mit Willkommensrabatt (sections/kunnie-newsletter-popup.liquid). Mechanik wie im Fackelmann-UK-Theme
// (assets/fk-newsletter.js): erscheint nach data-delay Sekunden, nach dem Schließen erst nach data-days Tagen wieder,
// nach einer Anmeldung auf diesem Gerät nie mehr (localStorage `kunnie-newsletter` = { state, source, t }).
// Zusätzlich zu UK: wartet, solange Shopifys Cookie-Banner oder ein anderer Dialog (Warenkorb, Suche, Menü) offen ist,
// und zeigt nach dem Absenden Erfolg bzw. Fehler im Popup — aber nur, wenn das Popup die Quelle war (das Footer-Formular
// ist ebenfalls ein Shopify-Kundenformular und löst dieselbe Rückkehr mit ?customer_posted=true aus).

const KEY = 'kunnie-newsletter';
const DAY = 24 * 60 * 60 * 1000;
const RESULT_WINDOW = 10 * 60 * 1000; // Rückkehr nach dem Absenden gilt höchstens 10 min lang als „aus dem Popup“

const state = {
  read() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null') || {};
    } catch {
      return {};
    }
  },
  write(patch) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...this.read(), ...patch, t: Date.now() }));
    } catch {
      /* kein Speicher (privater Modus) – Popup erscheint dann je Besuch */
    }
  },
};

const posted = new URLSearchParams(location.search).get('customer_posted') === 'true';

const isVisible = (element) => !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';

class KunnieNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => {
      document.dispatchEvent(new CustomEvent('kunnie:track', { detail: { event: 'newsletter_popup_dismissed', properties: { source: 'popup' } } }));
      if (state.read().state !== 'submitted') state.write({ state: 'dismissed' });
    });
    this.querySelector('form')?.addEventListener('submit', () => state.write({ state: 'submitted', source: 'popup' }));

    const saved = state.read();
    const result = this.querySelector('[data-state]')?.dataset.state; // success | error, vom Server gerendert
    const fromPopup = saved.source === 'popup' && Date.now() - (saved.t || 0) < RESULT_WINDOW;
    if (result && fromPopup) {
      if (result === 'error') state.write({ state: 'shown' }); // erneut versuchen erlaubt
      this.open(0);
      return;
    }
    if (posted) {
      state.write({ state: 'submitted', source: saved.source || 'footer' });
      return;
    }
    if (!this.shouldShow(saved)) return;
    this.timer = setTimeout(() => this.open(0), (Number(this.dataset.delay) || 30) * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  shouldShow(saved) {
    if (saved.state === 'submitted') return false;
    const days = Number(this.dataset.days) || 7;
    return !(saved.state === 'dismissed' && Date.now() - (saved.t || 0) < days * DAY);
  }

  open(attempt) {
    if (this.dialog.open) return;
    // Nie über dem Cookie-Banner (erst entscheiden lassen); andere Dialoge höchstens 60 s abwarten, dann trotzdem.
    const cookieBanner = isVisible(document.getElementById('shopify-pc__banner'));
    const otherDialog = !!document.querySelector('dialog[open]');
    if (cookieBanner || (otherDialog && attempt < 30)) {
      this.timer = setTimeout(() => this.open(attempt + 1), 2000);
      return;
    }
    this.dialog.showModal();
    document.dispatchEvent(new CustomEvent('kunnie:track', { detail: { event: 'newsletter_popup_shown', properties: { source: 'popup', delay_seconds: Number(this.dataset.delay) || 30 } } }));
    this.setAttribute('data-open', '');
    if (state.read().state !== 'submitted') state.write({ state: 'shown' });
    const input = this.dialog.querySelector('input[type="email"]');
    if (input && window.matchMedia('(min-width: 750px)').matches) input.focus();
  }
}

if (!customElements.get('kunnie-newsletter-popup')) customElements.define('kunnie-newsletter-popup', KunnieNewsletterPopup);
